__turbopack_context__.v({
  "Column": "DropdownMenu-module-scss-module__ZxvHsq__Column",
  "Info": "DropdownMenu-module-scss-module__ZxvHsq__Info",
  "Inner": "DropdownMenu-module-scss-module__ZxvHsq__Inner",
  "List": "DropdownMenu-module-scss-module__ZxvHsq__List",
  "Menu": "DropdownMenu-module-scss-module__ZxvHsq__Menu",
  "Wrapper": "DropdownMenu-module-scss-module__ZxvHsq__Wrapper",
  "showInner": "DropdownMenu-module-scss-module__ZxvHsq__showInner",
  "showMenu": "DropdownMenu-module-scss-module__ZxvHsq__showMenu",
});
